/**
 * EmptyState Component
 * Displays empty state messages (no results, no roles, etc.)
 */

import React from 'react';

const EmptyState = ({ searchTerm, onClearSearch, rolesCount }) => {
  // No roles found
  if (rolesCount === 0 && !searchTerm) {
    return (
      <tr>
        <td colSpan={100} className="no-results">
          <div className="no-results-content">
            <i className="bi bi-inbox"></i>
            <h3>No roles found</h3>
            <p>Create your first role to get started</p>
          </div>
        </td>
      </tr>
    );
  }

  // No search results
  if (searchTerm) {
    return (
      <tr>
        <td colSpan={rolesCount + 1} className="no-results">
          <div className="no-results-content">
            <i className="bi bi-search"></i>
            <h3>No permissions found</h3>
            <p>No permissions match your search: <strong>"{searchTerm}"</strong></p>
            <button 
              className="clear-search-btn"
              onClick={onClearSearch}
            >
              Clear Search
            </button>
          </div>
        </td>
      </tr>
    );
  }

  return null;
};

export default EmptyState;

